(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shop-category-nav"] && !Shopify.designMode) return;
  try {
    // On phones the categories are one scrolling row: bring the current one
  // into view instead of leaving it past the edge.
  document.querySelectorAll('.fa-shop-cats__list').forEach((list) => {
    const current = list.querySelector('[aria-current="page"]');
    if (!current || list.scrollWidth <= list.clientWidth) return;
    list.scrollLeft = current.offsetLeft - (list.clientWidth - current.offsetWidth) / 2;
  });
  } catch(e) { console.error(e); }
})();

})();
